module.exports = __webpack_public_path__ + "img/sum.dcba7b5b.jpg";